import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/caikuma_refer_promotion.svg'


const _withScopeId = n => (_pushScopeId("data-v-4c6f7449"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column align-items-center mb-4"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, "\n        初勤務完了済のため、ご利用いただけません\n      ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "refer-promotion-img",
  src: _imports_0
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-size-14 text-mild section-title" }, "招待コード入力", -1))
const _hoisted_5 = { class: "mb-3" }

import { computed } from "vue";
import TextFieldGroup from "@/components/molecules/form/TextFieldGroup.vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import ReferAttention from "@/components/organisms/mypage/referPromotion/ReferAttention.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferredTab',
  props: {
  alreadyReferred: {
    type: Boolean,
    required: true
  },
  alreadyWorked: {
    type: Boolean,
    required: true
  },
  canApplyPromotion: {
    type: Boolean,
    required: true
  },
  promotionCode: {
    type: String,
    required: true
  }
},
  emits: ["click", "update:promotionCode"],
  setup(__props, { emit: emits }) {

const props = __props;





const promotionCodeValue = computed({
  get: () => props.promotionCode,
  set: (value: string) => {
    emits("update:promotionCode", value);
  }
});

const submitButtonText = computed(() => {
  return props.alreadyReferred ? "登録済" : "登録";
});

const onClick = () => {
  emits("click");
};

return (_ctx: any,_cache: any) => {
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'gray-out': !__props.canApplyPromotion })
  }, [
    (__props.alreadyWorked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createTextVNode(),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _hoisted_4,
    _createTextVNode(),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_CustomValidationObserver, { ref: "vObserver" }, {
        default: _withCtx(({ handleSubmit }) => [
          _createVNode(_component_ValidationProvider, {
            name: "招待コード",
            rules: { required: true, length: 8 },
            vid: "code"
          }, {
            default: _withCtx((validationState) => [
              _createVNode(TextFieldGroup, {
                modelValue: promotionCodeValue.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((promotionCodeValue).value = $event)),
                disabled: !__props.canApplyPromotion,
                placeholder: "招待コードを入力してください",
                validationState: validationState,
                class: "mt-3"
              }, null, 8, ["modelValue", "disabled", "validationState"])
            ]),
            _: 1
          }),
          _createTextVNode(),
          _createVNode(AppButton, {
            block: "",
            disabled: !__props.canApplyPromotion || __props.alreadyReferred,
            class: "text-size-14 mt-2",
            onClick: ($event: any) => (handleSubmit(onClick))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(submitButtonText.value), 1)
            ], undefined, true),
            _: 2
          }, 1032, ["disabled", "onClick"])
        ]),
        _: 1
      }, 512)
    ])
  ], 2))
}
}

})